"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStarted() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative overflow-hidden py-16 min-h-[400px] !bg-transparent !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/business_consulting_meeting_professional.png)] !text-[hsl(0,0%,100%)] bg-cover bg-center !h-[500px] md:py-20 md:min-h-[500px] lg:min-h-[600px]">
      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Link to="/BookConsultationPage">
            <Button size="lg" className="text-primary-foreground inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 transition-all duration-150 !text-[hsl(0,0%,100%)] !bg-[hsl(22,78%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-md hover:ring-2 hover:ring-primary/30 active:translate-y-0">
              Book Your Consultation
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}